import { render, staticRenderFns } from "./IssueListByInvestId.vue?vue&type=template&id=097d6be0&scoped=true"
import script from "./IssueListByInvestId.vue?vue&type=script&lang=js"
export * from "./IssueListByInvestId.vue?vue&type=script&lang=js"
import style0 from "./IssueListByInvestId.vue?vue&type=style&index=0&id=097d6be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097d6be0",
  null
  
)

export default component.exports